<template>
  <nav
    class="navbar navbar-expand-lg navbar-absolute"
    :class="{ 'bg-white': showMenu, 'navbar-transparent': !showMenu }"
  >
    <div class="container-fluid">
      <div class="navbar-wrapper">
        <div class="navbar-minimize d-inline"><sidebar-toggle-button /></div>
        <div
          class="navbar-toggle d-inline"
          :class="{ toggled: $sidebar.showSidebar }"
        ></div>
        <a class="navbar-brand" href="javascript:void(0)"> {{ $route.name }}</a>
      </div>
      <button
        class="navbar-toggler"
        type="button"
        @click="toggleMenu"
        data-toggle="collapse"
        data-target="#navigation"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-bar navbar-kebab"></span>
        <span class="navbar-toggler-bar navbar-kebab"></span>
        <span class="navbar-toggler-bar navbar-kebab"></span>
      </button>
      <div class="collapse navbar-collapse show text-left" v-show="showMenu">
        <ul class="navbar-nav" :class="$rtl.isRTL ? 'mr-auto' : 'ml-auto'">
          <li class="d-none d-lg-block d-xl-block">
            <p class="d-flex align-items-center h-100">
              {{ this.dados.nome }}
            </p>
          </li>
          <drop-down>
            <a href="#" class="dropdown-toggle nav-link" data-toggle="dropdown">
              <div class="photo">
                <img src="@/assets/img/placeholder.jpg" alt="Profile Photo" />
              </div>
              <b class="caret d-none d-lg-block d-xl-block"></b>
              <p class="d-lg-none">
                {{ this.dados.nome }}
              </p>
            </a>
            <ul class="dropdown-menu dropdown-navbar">
              <li class="nav-link" @click="logout()">
                <a href="javascript:void(0)" class="nav-item dropdown-item"
                  >Sair</a
                >
              </li>
            </ul>
          </drop-down>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import DropDown from "@/components/Dropdown.vue";
import Modal from "@/components/Modal.vue";
import SidebarToggleButton from "./SidebarToggleButton.vue";

export default {
  components: {
    DropDown,
    Modal,
    SidebarToggleButton,
  },
  data() {
    return {
      searchModalVisible: false,
      searchQuery: "",
      showMenu: false,
      imgRecente: "",
      dados: "",
    };
  },
  mounted() {
    if (document.body.classList != "sidebar-mini") {
      document.body.classList.toggle("sidebar-mini");
    }
  },
  methods: {
    carregarDados() {
      this.dados = JSON.parse(this.$session.get("dados"));
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    router(param) {
      this.$router.push(param);
    },

    logout() {
      if (confirm("deseja sair?")) {
        this.$cookies.keys().forEach((cookie) => this.$cookies.remove(cookie));

        this.$session.clear("w_");
        this.$session.clear("dados");
        this.$session.clear("facial");

        this.$router.push("/login");
      }
    },
  },
  created() {
    this.carregarDados();
  },
  computed: {
    isRTL() {
      return this.$rtl.isRTL;
    },
  },
};
</script>
<style></style>
